<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-6 col-sm-4 text-center text-sm-left mb-4 mb-sm-0">
        <span
          :class="{'asian-fontsize' : ['ko','ja','zh'].includes($t.locale)}"
        >{{ $t("upgrade.title")}}</span>
        <h3 class="page-title">{{ $t("upgrade.upgradeplan")}}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 billing-box mx-auto mt-4">
        <div class="card card-small edit-user-details mb-4">
          <div class="card-body p-0">
            <div class="current-plan-name m-0">
              <router-link
                :to="{ name: 'plan' }"
                tag="a"
                class="mt-4 ml-4 font-weight-bold btn btn-md btn-primary"
              >{{ $t("upgrade.chooseplanbtn")}}</router-link>
              <div class="col-lg-12 mx-auto px-4 py-4 w-100">
                <div class="chosen-plan-box">
                  <div class="page-header col-8">
                    <span class="text-uppercase page-subtitle">{{ $t("upgrade.chosenplan")}}</span>
                    <h3 class="font-weight-bold mt-1 mb-1">Spring Pro</h3>
                    <p class="mb-2">{{ $t("upgrade.chosenplansub")}}</p>
                  </div>
                  <div class="page-header box-price">
                    <div
                      class="text-price text-uppercase page-subtitle"
                    >{{ selectedPlan === 'month' ? 'per month' : 'per year'}}</div>
                    <h3 class="font-weight-bold mt-1">
                      <small>$</small>
                      {{selectedPlan === 'month' ? '199' : '1999.99'}}
                      <!-- <sup class="underline">99</sup> -->
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <article class="card bottom-radius-only">
              <div class="card-body px-5 pb-5 pt-4">
                <form role="form">
                  <!-- Form Group -->
                  <h5 class="font-weight-bold mb-4 mx-auto">{{ $t("upgrade.paywithcard")}}</h5>
                  <div class="form-group">
                    <label for="name">{{ $t("upgrade.fullname")}}</label>
                    <div class="input-group">
                      <d-input type="text" class="form-control" name="name" required />
                    </div>
                    <!-- Input Group -->
                  </div>
                  <!-- Input -->
                  <div class="row">
                    <div class="form-group col-12">
                      <label for="cardNumber">{{ $t("upgrade.cardnumber")}}</label>
                      <div id="card-element"></div>

                      <!-- Input Group -->
                    </div>
                  </div>
                  <button
                    class="mt-4 font-weight-bold btn btn-success btn-block py-3 pay-btn"
                    type="button"
                    @click="pay"
                    :disabled="!valid"
                  >{{ $t("upgrade.paywithcardbtn")}}</button>
                </form>
                <p class="mt-4 text-light">
                  {{ $t("upgrade.detail")}}
                  <a href="/terms">{{ $t("upgrade.terms")}}.</a>
                </p>
              </div>
              <!-- End Card Body -->
            </article>
            <!-- End Card -->
          </div>
        </div>
        <div class="secure float-left">
          <span>
            <i class="material-icons float-left">lock</i>
          </span>
          <div class="float-right">
            {{ $t("upgrade.secure")}}
            <br />
            <span>{{ $t("upgrade.payment")}}</span>
          </div>
        </div>
        <div class="float-right mb-4">
          <img
            src="@/assets/images/stripe-powered.png"
            alt="powered by stripe"
            class="mb-4 stripe-logo"
          />
        </div>
      </div>
    </div>
  </d-container>
</template>

<script>
import { USER_UPGRADE } from "@/store/types";

export default {
  data() {
    return {
      complete: false,
      stripeOptions: {},
      valid: false
    };
  },
  computed: {
    selectedPlan() {
      return this.$route.params.selectedPlan;
    }
  },
  mounted() {
    let script = document.createElement("script");
    script.onload = () => {
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);
      this.card = this.stripe.elements().create("card");
      this.card.mount("#card-element");
      this.card.on("change", event => {
        if (event.complete == true) {
          this.valid = true;
        }
      });
    };
    script.async = true;
    script.src = "https://js.stripe.com/v3/";
    document.head.appendChild(script);
  },
  methods: {
    async pay() {
      const plan = this.selectedPlan;
      const data = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.card
      });

      await this.$store.dispatch(USER_UPGRADE, {
        plan,
        token: data.paymentMethod
      });

      this.$router.push({ name: "pro-plan" });
    }
  }
};
</script>

<style lang="scss" scoped>
.billing-box {
  max-width: 650px;
  /* font-family: "Source Sans Pro" !important; */
}

.chosen-plan-box {
  border: 2px solid #007bff;
  width: 100%;
  padding: 20px;
  border-radius: 8px;
}

.pay-btn {
  font-size: 1rem !important;
}

.box-price {
  position: absolute;
  top: 3rem;
  right: 3.5rem;
}

.text-price {
  font-size: 0.7rem !important;
}
</style>